import { NextApiResponseBody } from 'types/bolt-api/request'
import { CompanyCreditCheckResponseBody, CompanyCreditCheckRequestPathParams } from '@boltenergy-be/shared'

export const companyCreditCheck = async ({
  enterpriseNumber
}: CompanyCreditCheckRequestPathParams): Promise<NextApiResponseBody<CompanyCreditCheckResponseBody>> => {
  try {
    const res = await fetch(`/api/utilities/companies/${enterpriseNumber}/credit-check`, {
      method: 'GET'
    })

    return (await res.json()) as NextApiResponseBody<CompanyCreditCheckResponseBody>
  } catch (error) {
    return { success: false }
  }
}
